import { ICopyChecklistServicoUseCase } from "../../../presentation/useCases/create/copy_checklist_servico_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CopyChecklistServicoUseCase
 */

export class CopyChecklistServicoUseCase implements ICopyChecklistServicoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async copyChecklistServico(
    idChecklistServico: number,
    codigo: string,
    nroRevisao: string,
    descricao: string,
  ): Promise<void> {
    await this.repository.copyChecklistServico(
      idChecklistServico,
      codigo,
      nroRevisao,
      descricao,
    );
  }
}
